import { LitElement, html } from "lit-element";
import "./tone-viz";

class MidiContainer extends LitElement {
  static get properties() {
    return {
      availableInputs: { type: Array },
      value: { type: Number },
    };
  }

  constructor() {
    super();
  }

  render() {
    return html`
      <!-- <midi-in
        position="absolute"
        width="100%"
        height="100%"
        backgroundColor="rgb(0, 0, 0)"
      ></midi-in>

      <tone-viz
        name="horizontal"
        position="absolute"
        transport
        origin="right"
        transportNoteSpeed="16n"
        noteFadeSpeed=".2"
        size="1"
        mode="sequential-position"
        numNotes="16"
        width="100%"
        height="100%"
        noteColor="rgb(0, 0, 255)"
        noteOpacity=".5"
        noteMixBlendMode="screen"
      ></tone-viz>

      <tone-viz
        name="horizontal"
        position="absolute"
        transport
        origin="right"
        transportNoteSpeed="27n"
        noteFadeSpeed=".2"
        size="1"
        mode="sequential-position"
        numNotes="38"
        width="100%"
        height="100%"
        noteColor="rgb(0, 0, 200)"
        noteOpacity=".5"
        noteMixBlendMode="screen"
      ></tone-viz>

      <tone-viz
        name="horizontal"
        position="absolute"
        transport
        origin="right"
        transportNoteSpeed="44n"
        noteFadeSpeed=".2"
        size="1"
        mode="sequential-position"
        numNotes="14"
        width="100%"
        height="100%"
        noteColor="rgb(0, 50, 255)"
        noteOpacity=".5"
        noteMixBlendMode="screen"
      ></tone-viz>

      <tone-viz
        name="horizontal"
        position="absolute"
        transport
        origin="right"
        transportNoteSpeed="44n"
        noteFadeSpeed=".2"
        size="1"
        mode="sequential-position"
        numNotes="14"
        width="100%"
        height="100%"
        noteColor="rgb(0, 50, 255)"
        noteOpacity=".5"
        noteMixBlendMode="screen"
      ></tone-viz> -->

      <!-- <tone-viz
        name="horizontal"
        position="absolute"
        transport
        origin="left"
        transportNoteSpeed="47n"
        noteFadeSpeed=".2"
        size="1"
        mode="sequential-position"
        numNotes="19"
        width="100%"
        height="100%"
        noteColor="rgb(0, 0, 200)"
        noteOpacity=".7"
        noteMixBlendMode="color"
      ></tone-viz>

      <tone-viz
        name="horizontal"
        position="absolute"
        transport
        origin="right"
        transportNoteSpeed="32n"
        noteFadeSpeed=".2"
        size="1"
        mode="sequential-position"
        numNotes="15"
        width="100%"
        height="100%"
        noteColor="rgb(0, 250, 0)"
        noteOpacity=".7"
        noteMixBlendMode="screen"
      ></tone-viz>

      <tone-viz
        name="horizontal"
        position="absolute"
        transport
        origin="right"
        transportNoteSpeed="53n"
        noteFadeSpeed=".2"
        size="1"
        mode="sequential-position"
        numNotes="15"
        width="100%"
        height="100%"
        noteColor="rgb(0, 100, 0)"
        noteOpacity=".7"
        noteMixBlendMode="screen"
      ></tone-viz>

      <tone-viz
        name="horizontal"
        position="absolute"
        transport
        origin="left"
        transportNoteSpeed="60n"
        noteFadeSpeed=".1"
        size="1"
        mode="sequential-position"
        numNotes="30"
        width="100%"
        height="100%"
        noteColor="rgb(0, 200, 0)"
        noteOpacity=".5"
        noteMixBlendMode="color"
      ></tone-viz> -->

      <!-- <tone-viz
        name="horizontal"
        position="absolute"
        transport
        origin="left"
        transportNoteSpeed="10n"
        noteFadeSpeed="2"
        size="1"
        mode="sequential-position"
        numNotes="30"
        width="100%"
        height="100%"
        noteColor="rgb(255, 255, 0)"
        noteOpacity="1"
        noteMixBlendMode="color"
      ></tone-viz> -->

      <tone-viz
        name="horizontal"
        position="absolute"
        transport
        origin="right"
        transportNoteSpeed="30n"
        noteFadeSpeed="1"
        size="1"
        mode="sequential-position"
        numNotes="43"
        width="100%"
        height="100%"
        noteColor="rgb(0, 255, 0)"
        noteOpacity="1"
        noteMixBlendMode="color"
        noteHeightOrigin="bottom"
        lengthIteratorStep="43"
      ></tone-viz>

      <tone-viz
        name="horizontal"
        position="absolute"
        transport
        origin="left"
        transportNoteSpeed="30n"
        noteFadeSpeed="1"
        size="1"
        mode="sequential-position"
        numNotes="43"
        width="100%"
        height="100%"
        noteColor="rgb(255, 0, 0)"
        noteOpacity="1"
        noteMixBlendMode="screen"
        noteHeightOrigin="top"
        lengthIteratorStep="43"
      ></tone-viz>

      <tone-viz
        name="horizontal"
        position="absolute"
        transport
        origin="left"
        transportNoteSpeed="30n"
        noteFadeSpeed="1"
        size="1"
        mode="sequential-position"
        numNotes="43"
        width="100%"
        height="100%"
        noteColor="rgb(255, 255, 50)"
        noteOpacity="1"
        noteMixBlendMode="normal"
        noteHeightOrigin="top"
        lengthIteratorStep="44"
      ></tone-viz>
    `;
  }
}

customElements.define("midi-container", MidiContainer);
